var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15C30 6.72499 23.275 0 15 0C6.72499 0 0 6.72499 0 15C0 23.275 6.72499 30 15 30C23.275 30 30 23.275 30 15ZM21.0609 10.4438L16.5152 14.9895L21.0609 19.5352L19.5457 21.0504L15 16.5047L10.4543 21.0504L8.9391 19.5352L13.4848 14.9895L8.9391 10.4438L10.4543 8.92858L15 13.4742L19.5457 8.92858L21.0609 10.4438Z",
    fill: "#FF475D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon_error.6ee09e9f50abfed737b858306cbe3465.svg";
export { ForwardRef as ReactComponent };